import Button from '@lushdigital/ui/button';
import { useRouter } from 'next/router';
import UseTranslation from 'next-translate/useTranslation';
import packageJson from 'package.json';
import React from 'react';
import Cookies from 'universal-cookie';
import { clarity } from '@/manager-next/helpers/clarity';
import { useFeatures } from '@/tills/context/features';

const CONSENT_COOKIE_NAME = 'manager_consent';

const CookieBanner = () => {
  const { t } = UseTranslation('tills');
  const features = useFeatures();
  const router = useRouter();
  const cookies = new Cookies();

  const [isVisible, setIsVisible] = React.useState(false);

  const managerVersion = packageJson.version;

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const hasConsent = cookies.get(CONSENT_COOKIE_NAME);
    if (!hasConsent) {
      setIsVisible(true);
      clarity.stopTracking();
    }

    if (hasConsent === 'true') {
      try {
        clarity.init();

        if (clarity.hasStarted()) {
          clarity.setTags({
            shopId: String(features?.shopId ?? ''),
            countryCode: String(features?.countryCode ?? ''),
            timezone: String(features?.timezone ?? ''),
            managerVersion
          });
        }
      } catch (error) {
        console.warn('Clarity initialization failed:', error);
      }
    }
  }, []);

  if (!features?.featureFlags || !features.featureFlags.includes('clarity')) {
    return null;
  }

  const acceptCookies = () => {
    const sixMonths = 180 * 24 * 60 * 60 * 1000;
    cookies.set(CONSENT_COOKIE_NAME, 'true', {
      path: '/',
      maxAge: sixMonths / 1000
    });
    setIsVisible(false);
    router.reload();
  };

  const declineCookies = () => {
    cookies.set(CONSENT_COOKIE_NAME, 'false', { path: '/' });
    clarity.consent(false);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="border-t-1 fixed inset-x-0 bottom-0 z-50 border-white bg-black py-4 text-white shadow-lg">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 sm:flex-row">
        <p className="text-center text-sm sm:text-left">{t('COOKIE_BANNER_MESSAGE')}</p>

        <div className="flex gap-3">
          <Button theme="error" onClick={declineCookies}>
            {t('DECLINE')}
          </Button>
          <Button theme="inverse" onClick={acceptCookies}>
            {t('ACCEPT')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
